export default __webpack_public_path__ + "static/media/part1_a4_m.51c16dd5.png";